<template>
  <b-card title="Edit Ekiosk User">
    <b-col cols="12">
      <b-row class="mb-2">
        <b-col cols="4">
          <b-button variant="primary" :to="{ name: 'ekiosk-user-management' }">
            Back to Ekiosk User
          </b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <validation-observer ref="editAdmin">
            <b-form-group>
              <span>First Name <span style="color:red">(*)</span></span>
              <validation-provider
                v-slot="{ errors }"
                name="FirstName"
                rules="required"
              >
                <b-form-input
                  v-model="userForm.firstName"
                  type="text"
                  placeholder="FirstName"
                  :state="errors.length > 0 ? false : null"
                  style="margin-top:5px !important;"
                  disabled
                ></b-form-input>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group>
              <span>First Name <span style="color:red">(*)</span></span>
              <validation-provider
                v-slot="{ errors }"
                name="LastName"
                rules="required"
              >
                <b-form-input
                  v-model="userForm.lastName"
                  type="text"
                  placeholder="LastName""
                  :state="errors.length > 0 ? false : null"
                  style="margin-top:5px !important;"
                  disabled
                ></b-form-input>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group>
              <span>Email <span style="color:red">(*)</span></span>
              <validation-provider
                name="Email"
                rules="required|email"
                v-slot="{ errors }"
              >
                <b-form-input
                  v-model="userForm.email"
                  type="email"
                  placeholder="Email"
                  :state="errors.length > 0 ? false : null"
                  style="margin-top:5px !important;"
                  disabled
                ></b-form-input>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group>
              <span>Status <span style="color:red">(*)</span></span>
              <v-select
                v-model="userForm.status"
                placeholder="----- Select Status -----"
                :options="statusList"
                label="label"
                :clearable="false"
                style="margin-top:5px !important;"
                class="mb-1"
              />
            </b-form-group>

          </validation-observer>
        </b-col>
        <b-col cols="12">
          <b-button variant="success" @click="saveEdit"> Save </b-button
          >
        </b-col>
      </b-row>
    </b-col>
  </b-card>
</template>

<script>
import { mapActions } from "vuex";
import axios from "@/axios";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email } from "@validations";
import { sleep } from "@/utils/utils.js";

export default {
  components: {
    "validation-observer": ValidationObserver,
    "validation-provider": ValidationProvider,
  },
  props: ["id"],
  data() {
    return {
      userForm: {}
    };
  },
  methods: {
    saveEdit() {
      let forSave = this.userForm;

      this.$refs.editAdmin.validate().then((result) => {
        if (result) {
          this.updateUser({ id: this.id, data: forSave })
          .then(async (response) => {
            this.$bvToast.toast(
              `Successfully updated user ${this.userForm.name}`,
              {
                title: "Success",
                variant: "success",
                solid: true,
              }
            );

            this.$router.go(-1);
          })
          .catch((e) => {
            console.log({ e });
            this.$bvToast.toast(
              `You have failed to create a user ${this.userForm.name}`,
              {
                title: "Failed",
                variant: "danger",
                solid: true,
              }
            );
          });
        }
      });
    },
    ...mapActions({
      updateUser: "auth/updateEkioskUser",
      getUser: "auth/getEkioskUser",
      updateDealer: "dealer/updateDealer",
      updateDealerV2: "dealer/updateDealerV2",
    })
  },
  computed: {
    statusList() {
      return ['Pending', 'Approved', 'Rejected']
    },
    allDealers() {
      var tempDealers = this.$store.getters["dealer/getDealers"].filter(
        (x) => x.status === ""
      );
      return tempDealers;
    },
  },
  async mounted() {
    await this.getUser(this.id)
      .then((res) => {
        this.userForm = res.data;
      })
      .catch((e) => {
        console.log(e);
      });
  },
  created() {
    document.title = "Ekiosk User | RSP";
  },
};
</script>
